let isInitRecapcha = false;
let isLoadRecapcha = false;

const loadReCapcha = () => {
    if (typeof GOOGLE_RECAPCHA_KEY === "undefined") {
        return;
    }

    let script = document.getElementById("google-recapcha");

    if (script) {
        updateReCapcha();
        return;
    }

    script = document.createElement("script");
    script.id = "google-recapcha";
    script.src = "https://www.google.com/recaptcha/api.js?render=" + GOOGLE_RECAPCHA_KEY;

    script.onload = () => {
        script.onload = null;
        updateReCapcha();
    };

    document.body.appendChild(script);
}

const updateReCapcha = () => {
    if (typeof grecaptcha === "undefined") {
        return;
    }

    grecaptcha.ready(() => {
        grecaptcha
            .execute(GOOGLE_RECAPCHA_KEY, {
                action: "validate_captcha",
            })
            .then(token => {
                isInitRecapcha = true;
                document.querySelectorAll('input[name="recaptcha-response"]').forEach(input => (input.value = token));
            });
    });
}

const initReCapcha = () => {
    document.body.addEventListener("keyup", e => {
        if (isLoadRecapcha) {
            return;
        }
        isLoadRecapcha = true;
        loadReCapcha();
    });
}

export { initReCapcha, updateReCapcha };